export const COLORS = ["ffd9a5", "c8ecfd", "bff0c9", "d9cefb", "fdc8c8"];
export const CONFIG = {
  baseURL: "https://eu.ui-avatars.com/api/",
  fontSize: "0.4",
  background: "random"
};

export const STATUS_NAMES = {
  APPLIED: "Beworben",
  REJECTED: "Abgesagt",
  AUTOMATIC_REJECTED: "Automatisch abgesagt",
  CONTACTED: "Kontaktiert",
  INTERVIEWED: "Zur Vorstellung",
  HIRED: "Eingestellt",
  ARCHIVED: "Archiviert",
  SNOOZED: "Warten auf Rückmeldung",
  QUALIFIED: "Qualifiziert",
  FORWARDED: "Weitergeleitet an Fachabteilung"
};
